import { render, staticRenderFns } from "./MyDownloadsHeader.vue?vue&type=template&id=68ad61ec&scoped=true"
import script from "./MyDownloadsHeader.vue?vue&type=script&lang=js"
export * from "./MyDownloadsHeader.vue?vue&type=script&lang=js"
import style0 from "./MyDownloadsHeader.vue?vue&type=style&index=0&id=68ad61ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad61ec",
  null
  
)

export default component.exports